const API = process.env.REACT_APP_BACKEND_URL;

export const adminApi = async (path, { method = "GET", body } = {}) => {
  const res = await fetch(`${API}/api${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "Request failed");
  return data;
};

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}/api/admin/upload`, { method: "POST", credentials: "include", body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "Upload failed");
  return data;
};

export const streamSSE = async (path, onDelta) => {
  const res = await fetch(`${API}/api${path}`, { method: "POST", credentials: "include" });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.detail || "Request failed"); }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.delta) onDelta(ev.delta);
    }
  }
};

export const STATUS_LABELS = { idea: "Idea", researching: "Researching", ai_draft: "AI Draft", review: "Review", approved: "Approved", scheduled: "Scheduled", published: "Published" };
export const STATUS_COLORS = { idea: "bg-slate-500/20 text-slate-300", researching: "bg-blue-500/20 text-blue-300", ai_draft: "bg-violet-500/20 text-violet-300", review: "bg-amber-500/20 text-amber-300", approved: "bg-emerald-500/20 text-emerald-300", scheduled: "bg-cyan-500/20 text-cyan-300", published: "bg-green-500/20 text-green-300" };

export const StatusBadge = ({ status }) => (
  <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${STATUS_COLORS[status] || "bg-slate-500/20 text-slate-300"}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

export const AdminHeader = ({ title, subtitle, testId, children }) => (
  <div className="flex items-center justify-between mb-8 gap-4">
    <div>
      <h1 className="text-2xl font-bold text-white mb-1" data-testid={testId}>{title}</h1>
      {subtitle && <p className="text-sm text-[var(--text-secondary)]">{subtitle}</p>}
    </div>
    {children}
  </div>
);

export const EmptyState = ({ text, testId }) => (
  <div className="bg-[var(--bg-card)] border-glow rounded-xl p-12 text-center" data-testid={testId}>
    <p className="text-[var(--text-secondary)]">{text}</p>
  </div>
);
